import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let AxesDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-axes';
        }
    }
});
export const AxesPlugin = {
    name: 'e-axes',
    install(Vue) {
        Vue.component(AxesPlugin.name, AxesDirective);
    }
};
export let AxisDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-axis';
        }
    }
});
export const AxisPlugin = {
    name: 'e-axis',
    install(Vue) {
        Vue.component(AxisPlugin.name, AxisDirective);
    }
};
